import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Select from 'components/forms/Select';
import { getCampaignManagerOption } from 'utils/campaign';

import { getUsers } from 'redux/actions/userActions';


class CampaignManagersFilter extends Component {
  static propTypes = {
    value: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired,
    users: PropTypes.shape({
      results: PropTypes.shape({}.isRequired),
    }).isRequired,
    getUsers: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.getUsers({ groups__name: 'Campaign Manager,Campaign Director' });
  }

  render() {
    const { users, value, onChange } = this.props;
    const campaignManagerOptions = users.results &&
      users.results.map(user => (getCampaignManagerOption(user)));

    return (
      <Select
        isMulti
        placeholder="Campaign managers"
        value={value}
        onChange={onChange}
        options={campaignManagerOptions || []}
      />
    );
  }
}

export default compose(connect(
  state => ({ users: state.users }),
  { getUsers },
))(CampaignManagersFilter);
